import is from '@sindresorhus/is';
import { useContext, useMemo } from 'react';

import { LanguageContent } from './LanguageContent';
import { ApplicationContext } from '../../../../../../../shared/source/context/context';
import {
    useUserLanguageSkillsOptionsQuery,
    useUserLanguageSkillsQuery,
} from '../../../../../../../shared/source/query-hooks/language-skills';
import { EditButton } from '../../../../common/buttons/EditButton';
import { editUserLanguagesUrl } from '../../constants';
import { AddButton } from '../../user-profile/common/ActionButtons';

import type { FunctionComponent } from 'react';

type LanguagesProps = {
    readonly userId: string;
};

export const Languages: FunctionComponent<LanguagesProps> = ({ userId }) => {
    const { data: userLanguageSkillOptions } = useUserLanguageSkillsOptionsQuery(userId);
    const { data: languageSkills, isFetching } = useUserLanguageSkillsQuery({
        enabled: Boolean(userLanguageSkillOptions?.canReadLanguages),
        userId,
    });
    const { actions, applicationState } = useContext(ApplicationContext);
    const { navigateTo } = actions;
    const { myUserProfile } = applicationState;
    const isCurrentUsersProfile = myUserProfile.get('id').mapOr(false, (myUserProfileId) => {
        return myUserProfileId === userId;
    });

    const action = useMemo(() => {
        if (!isCurrentUsersProfile) return null;

        const ActionsButton = is.array(languageSkills) && is.nonEmptyArray(languageSkills) ? EditButton : AddButton;

        return <ActionsButton aria-label="Edit Languages" onClick={() => navigateTo(editUserLanguagesUrl(userId))} />;
    }, [navigateTo, isCurrentUsersProfile, languageSkills, userId]);

    return <LanguageContent action={action} isFetching={isFetching} languageSkills={languageSkills} />;
};
